Model = require("./base_individual_model.coffee")
getJobProps = require("./get_job_props.coffee")

class JobModel extends Model
    model_type: coat.prop("jobs")

    getTrackProps: () ->
        if @loading()
            {
                job_id: @id(),
                error_message: "Model still loading; properties not available"
            }
        else if @requestError()
            {
                job_id: @id(),
                error_message: @requestErrorMessage()
            }
        else
            getJobProps(@)

module.exports = JobModel


// WEBPACK FOOTER //
// ./node_modules/musecoreui/models/individual/job_individual_model.coffee